import React from "react";
import { fonts } from "../Theme";
import { rawFonts } from "../Theme/fonts";
import { css } from "@linaria/core";
import classNames from "classnames";

interface Props
  extends React.HTMLAttributes<HTMLHeadingElement | HTMLParagraphElement | HTMLSpanElement> {
  type?: keyof typeof rawFonts;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  as?: React.ElementType<any>;
}

type P = React.PropsWithChildren<Props>;

// eslint-disable-next-line @typescript-eslint/no-unused-expressions
css`
  :global() {
    ${Object.keys(rawFonts)
      .map(type => `&.${type} { font: ${fonts[type as keyof typeof rawFonts]}}`)
      .join("")}
  }
`;

const getTagByStyle = (type: P["type"]) => {
  switch (type) {
    case "h1":
      return "h1";
    case "h2":
      return "h2";
    case "h3":
      return "h3";
    case "h4":
      return "h4";
    default:
      return "p";
  }
};

export const Text = ({ as, type = "body1", children, className, ...props }: P) => {
  const Component = as || getTagByStyle(type);

  return (
    <Component title={props.title} className={classNames([type, className])} {...props}>
      {children}
    </Component>
  );
};

export const H1 = ({ children, ...props }: Omit<P, "type" | "as">) => (
  <Text type="h1" {...props}>
    {children}
  </Text>
);

export const H2 = ({ children, ...props }: Omit<P, "type" | "as">) => (
  <Text type="h2" {...props}>
    {children}
  </Text>
);

export const H3 = ({ children, ...props }: Omit<P, "type" | "as">) => (
  <Text type="h3" {...props}>
    {children}
  </Text>
);

export const H4 = ({ children, ...props }: Omit<P, "type" | "as">) => (
  <Text type="h4" {...props}>
    {children}
  </Text>
);

export default Text;
